import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { reduce } from 'lodash'
import styles from './BreadcrumbStyle.module.scss'

class Breadcrumbs extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      breadcrumb: [],
    }
  }

  componentWillReceiveProps(newProps) {
    this.setBreadcrumbs(newProps)
  }

  setBreadcrumbs = (props) => {
    const { isMenuTop, menuTopData, menuLeftData } = props

    this.setState({
      breadcrumb: this.getBreadcrumb(props, isMenuTop ? menuTopData : menuLeftData),
    })
  }

  getPath(data, url, parents = []) {
    const items = reduce(
      data,
      (result, entry) => {
        if (result.length) {
          return result
        }
        if (!(entry.url instanceof RegExp) && entry.url === url) {
          return [entry].concat(parents)
        }
        if (entry.url instanceof RegExp && entry.url.test(url)) {
          return [entry].concat(parents)
        }
        if (entry.children) {
          const nested = this.getPath(entry.children, url, [entry].concat(parents))
          return (result || []).concat(nested.filter((e) => !!e))
        }
        if (entry.nestedURL) {
          const nested = this.getPath(entry.nestedURL, url, [entry].concat(parents))
          return (result || []).concat(nested.filter((e) => !!e))
        }
        return result
      },
      [],
    )
    return items.length > 0 ? items : [false]
  }

  getBreadcrumb = (props, items) => {
    const [activeMenuItem, ...path] = this.getPath(items, this.props.location.pathname)

    if (activeMenuItem && path.length) {
      return path.reverse().map((item, index) => {
        if (index === path.length - 1) {
          return (
            <span key={item.key}>
              <span className={`${styles.arrow} text-muted`} />
              {item.url ? (
                <Link to={item.url}>
                  <span>{item.title}</span>
                </Link>
              ) : (
                <span>{item.title}</span>
              )}

              <span className={styles.arrow} />
              <strong className={styles.activeMenu}>{activeMenuItem.title}</strong>
            </span>
          )
        }
        return (
          <span key={item.key}>
            <span className={styles.arrow} />
            <span>{item.title}</span>
          </span>
        )
      })
    }
    return (
      <span>
        <span className={styles.arrow} />
        <strong className={styles.activeMenu}>{activeMenuItem.title}</strong>
      </span>
    )
  }

  render() {
    const { breadcrumb } = this.state

    return (
      <div className={styles.breadcrumbs}>
        <div className="breadcrumbPath">
          <Link to="/home" className="text-muted">Home</Link>
          {breadcrumb}
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ menu }) => ({
  isMenuTop: menu.isMenuTop,
  menuTopData: menu.menuTopData,
  menuLeftData: menu.menuLeftData,
});

export default withRouter( connect(
  mapStateToProps,
)(Breadcrumbs))


// @todo the componentWillReceiveProp is being deprecated
